import React from 'react';

import ProjectIcon from '@atlaskit/icon/core/project';
import LinkMenuItem from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/link-menu-item-with-analytics/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import { SubspaceActions } from './SubspaceActions.tsx';

export type SubspaceMenuItemProps = {
	projectName: string;
	href: string;
	isSelected?: boolean;
	onClick?: () => void;
};
export const SubspaceMenuItem = ({ projectName, ...props }: SubspaceMenuItemProps): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<LinkMenuItem
			elemBefore={<ProjectIcon label={formatMessage(messages.projectIconLabel)} />}
			actionsOnHover={<SubspaceActions iconButtonSpacing="compact" />}
			{...props}
		>
			{projectName}
		</LinkMenuItem>
	);
};
